import { Autocomplete, Box, TextField } from "@mui/material";
import { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { Activite } from "../../../../models/Activite";
import { Caracteristique } from "../../../../models/Caracteristique";
import { Produit } from "../../../../models/Produit";
import { RequestToSend } from "../../../../models/RequestToSend";
import { Section } from "../../../../models/Section";
import { addRequestToSend } from "../../../../redux/features/appStateSlice";
import {
  useGetCaracteristiquesQuery,
  useGetSectionsQuery,
  useUpdateGroupProduitMutation,
  useUpdateProduitMutation,
} from "../../../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { GridContext } from "../../PlanogrammePage";

export interface IFormEditProduit {
  produit: Produit;
  section: Section;
  allCode: Activite[];
  setUnsaved: Dispatch<SetStateAction<boolean>>;
}

export const FormEditProduit = ({ produit, allCode, setUnsaved, section: productSection, }: IFormEditProduit) => {
  const gridContext = useContext(GridContext);

  const dispatch = useAppDispatch();
  const [updateGroup] = useUpdateGroupProduitMutation();
  const [updateProduit] = useUpdateProduitMutation();

  const d_inv01rp = useAppSelector((state) => state.appState.d_inv01rp);

  const { data: sections = [] as Section[] } = useGetSectionsQuery({
    div: "",
    simple: true,
    user: "",
    rech: "",
    treeView: false,
  });
  const { data: styles = [] as Caracteristique[] } = useGetCaracteristiquesQuery(productSection.carac_seq);

  const [isDirty, setIsDirty] = useState<boolean>(false);
  const [currentCollection, setCurrentCollection] = useState<string>(produit.prod_collection);
  const [currentSection, setCurrentSection] = useState<Section | null>(productSection);
  const [currentActivite, setCurrentActivite] = useState<Activite | null>(
    allCode.find((item) => item.act_cd === produit.act_cd) ?? null
  );
  const [currentStyle, setCurrentStyle] = useState<Caracteristique | null>(null);

  useEffect(() => {
    if (styles.length > 0) {
      const initialStyle = styles.find(style => style.carrep_txt === produit.style_aff) ?? null;
      setCurrentStyle(() => initialStyle);
    }
  }, [produit.style_aff, styles]);

  useEffect(() => {
    setUnsaved(isDirty);
  }, [isDirty, setUnsaved]);

  const handleSub = async () => {
    const sectionUpdate = {
      plans_seq: currentSection?.plans_seq,
      prod_num: produit.prod_num,
    };

    const updatedProduct = {
      ...produit,
      act_cd: currentActivite?.act_cd,
      prod_collection: currentCollection,
      plans_seq: currentSection?.plans_seq,
      style_aff: currentStyle?.carrep_txt,
    } as Produit;

    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Modifier section du produit ${produit.prod_num}`,
          updateGroup,
          () => { },
          {},
          sectionUpdate,
          []
        )
      )
    );
    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Modifier produit ${produit.prod_num}`,
          updateProduit,
          () => {
            setIsDirty(false);
            gridContext?.updateRow(updatedProduct);
          },
          {},
          updatedProduct,
          []
        )
      )
    );
  };

  return (
    <div data-component="form-edit-produit">
      {produit && (
        <Box sx={{ display: "flex" }}>
          <TextField
            value={currentCollection}
            onChange={(e) => {
              if (!isDirty) setIsDirty(true);
              setCurrentCollection(e.target.value);
            }}
            label={"Collection"}
            sx={{ width: 225, m: 1 }}
          />
          <Autocomplete
            value={currentSection || null}
            options={sections}
            getOptionLabel={(sec) => `${sec.plans_nom}`}
            onInputChange={(_event, newInputValue) => {
              if (sections.length > 0) {
                const newSection = sections.find((section) =>
                  section.plans_nom === newInputValue
                ) ?? null;

                if (newInputValue !== currentSection?.plans_nom)
                  setIsDirty(true);

                setCurrentSection(newSection);
              }
            }}
            sx={{ width: 225, m: 1 }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Section"
                sx={{ color: "#233044", background: "white" }}
              />
            )}
          />
          <Autocomplete
            value={currentActivite || null}
            options={allCode}
            getOptionLabel={(sec) => `${sec.act_aff}`}
            onInputChange={async (event, newInputValue) => {
              if (!isDirty && newInputValue !== currentActivite?.act_aff)
                setIsDirty(true);

              const newActivite = allCode.find((item) =>
                item.act_aff === newInputValue) ?? null;

              setCurrentActivite(newActivite);
            }}
            sx={{ width: 225, m: 1 }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Code d'activité"
                sx={{ color: "#233044", background: "white" }}
              />
            )}
          />

          <Autocomplete
            value={currentStyle}
            options={styles}
            getOptionLabel={(style) => style.carrep_txt}
            isOptionEqualToValue={(option, value) => {
              return option?.carrep_txt === value?.carrep_txt
            }}
            onChange={(_event, newValue) => {
              if (newValue?.carrep_txt !== currentStyle?.carrep_txt) {

                setCurrentStyle(newValue);
                setIsDirty(true);
              }
            }}
            sx={{ width: 225, m: 1 }}
            renderInput={(params) =>
              <TextField
                {...params}
                variant="outlined"
                label="Style"
                sx={{ color: "#233044", background: "white" }}
              />
            }
          />

          <span
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 28px",
              cursor: "pointer",
            }}
            className={`save-wrapper ${!isDirty || !d_inv01rp.canModify ? "custom-disabled" : ""}`}
            onClick={handleSub}
          >
            <span className={`k-icon k-font-icon k-i-save k-icon-xl`}></span>
          </span>
        </Box>
      )}
    </div>
  );
}
